var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoice = function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5c0-.8.7-1.5 1.5-1.5H20v7.5c0 .8-.7 1.5-1.5 1.5S17 8.3 17 7.5V5.1l-4.4 4.4c-.6.6-1.5.6-2.1 0-.6-.5-.6-1.5-.1-2.1L14.9 3h-2.4c-.8 0-1.5-.7-1.5-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 19h14v-8H1v8zm7-2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgInvoice;